import axios from "axios";
// eslint-disable-next-line
import React, { useContext, useEffect, useState } from "react";
import summaryApi from "../common/Api";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import Loading from "../components/loading/loading";
import UserContext from "../context/context";
import { MdDeleteOutline } from "react-icons/md";
import { MdOutlinePayments } from "react-icons/md";
import { HiPlusSmall } from "react-icons/hi2";
import { HiMiniMinusSmall } from "react-icons/hi2";
import { Link } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
const Cart = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const context = useContext(UserContext);
  const [clicked, setClicked] = useState(false);

  const fetchCartData = async () => {
    try {
      const token = Cookies.get("tokenApi");
      if (!token) {
        // console.error('Token not found!');
        toast.error("Please login first!", {
          position: "bottom-center",
          className: "custom-toast",
          autoClose: 2000,
          draggable: true,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggablePercent: 60,
        });
        return;
      }

      const response = await axios.get(summaryApi.cartProductList.url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      setData(response?.data?.data?.items);

      return response.data;
    } catch (error) {
      console.error("Error fetching cart data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePayment = async () => {
    try {
      const token = Cookies.get("tokenApi");
      if (!token) {
        toast.error("Please login first!", {
          position: "bottom-center",
          className: "custom-toast",
          autoClose: 2000,
          draggable: true,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggablePercent: 60,
        });
        return;
      }
      const response = await axios.post(
        summaryApi.paymentOrder.url,
        { cartItems: data },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );
      const stripePromise = await loadStripe(
        "pk_test_51OOD3AHBjBQwViWwEKTfPExe9Ok3nqNZwo13t4b0PQrq5QnKACzMCOJteKXFQvoTfpFXtTv1FMFIS7FWpPQMKxw100qbzR9t4N"
      );
      console.log("Payment response:", response.data);
      // Redirect to the session URL
      if (response.data.session.id) {
        stripePromise.redirectToCheckout({
          sessionId: response.data.session.id,
        });
        // window.location.href = response.data.session.url;
      } else {
        toast.error("Failed to retrieve payment URL.", {
          position: "bottom-center",
          className: "custom-toast",
          autoClose: 2000,
          draggable: true,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggablePercent: 60,
        });
      }
    } catch (error) {
      console.error("Error fetching cart data:", error);
      toast.error("Failed to initiate payment.", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
    }
  };

  const updateQuantity = async (productId, quantity) => {
    setClicked(true);
    try {
      const token = Cookies.get("tokenApi");
      if (!token) {
        toast.error("Please login first!", {
          position: "bottom-center",
          className: "custom-toast",
          autoClose: 2000,
          draggable: true,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggablePercent: 60,
        });
        return;
      }
      const response = await axios.post(
        summaryApi.updateCartProduct.url,
        { productId, quantity },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );
      setData(response?.data.data);
      toast.success("Quantity updated successfully!", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
    } catch (error) {
      console.error("Error updating quantity:", error);
      toast.error("Failed to update quantity.", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
    } finally {
      setClicked(false);
    }
  };

  const removeProduct = async (productId) => {
    setClicked(true);
    try {
      const token = Cookies.get("tokenApi");
      if (!token) {
        toast.error("Please login first!", {
          position: "bottom-center",
          className: "custom-toast",
          autoClose: 2000,
          draggable: true,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggablePercent: 60,
        });
        return;
      }
      await axios.delete(summaryApi.deleteCartProduct.url, {
        data: { productId },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      setClicked(false);
      setData((prevData) => prevData.filter((item) => item._id !== productId));
      context.fetchCartCount();
      toast.success("Product removed successfully!", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
    } catch (error) {
      console.error("Error removing product:", error);
      toast.error("Failed to remove product.", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
    } finally {
      // setClicked(false);
    }
  };

  useEffect(() => {
    fetchCartData();
    context.fetchCartCount();
  });

  if (loading) {
    return (
      <div>
        {" "}
        <Loading />{" "}
      </div>
    );
  }

  const calculateTotal = () => {
    let total = data.reduce(
      (total, item) => total +( item.product.discount * item.quantity * 50 ||  item.product.price * item.quantity * 50),
      0
    );
    return +total + 100;
  };

  const calculateTotalQuantity = () => {
    return data.reduce((total, item) => total + item.quantity, 0);
  };
  return (
    <div className="container mx-auto p-4 scroll-smooth">
      {data.length > 0 && !loading && (
        <h2
          style={{ fontFamily: "serif" }}
          className="block text-2xl font-bold pb-3 pt-3 md:pt-5 md:pb-5 uppercase"
        >
          {" "}
          Your Cart{" "}
        </h2>
      )}

      {/* no data  */}
      {data.length === 0 && !loading && (
        <div className=" flex justify-center items-center text-center animate-pulse duration-1000">
          <img
            src="https://adasglobal.com/img/empty-cart.png"
            alt="Empty Cart"
            className="w-full md:w-[50%] h-auto object-contain"
          />
        </div>
      )}

      <div className="flex flex-col md:flex-row gap-5  items-start md:items-start pt-5">
        {/* data section  */}
        <div
          // style={{ maxHeight: "calc(100vh - 150px)" }}
          className="w-full md:w-[65%] relative "
        >
          {data?.map((item, index) => (
            <Link
              to={`/product/${item?.product?._id}`}
              key={item?.product?._id}
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }}
              // key={index}
              className="flex items-center gap-3 mb-3 h-40 bg-white rounded relative shadow-md overflow-hidden"
            >
              <div className="absolute w-fit top-2 left-2 sm:right-2">
                <button
                  onClick={(event) => {
                    event.stopPropagation(); // Prevent redirect
                    event.preventDefault(); // Prevent redirect
                    removeProduct(item?._id);
                  }}
                  disabled={clicked}
                  className="text-2xl text-red-500 hover:text-red-700  cursor-pointer"
                >
                  <MdDeleteOutline />
                </button>
              </div>

              <div className="absolute w-fit top-[45%] right-2 ">
                <p className="px-4 text-gray-500 font-semibold text-xl">
                  {item?.product?.discount > 0 ? (
                    <div className="flex flex-row gap-3 items-center">
                      <span className=" text-xl font-bold ">
                        ${item?.product?.discount * item.quantity}.00
                      </span>
                    </div>
                  ) : (
                    <span className=" text-xl font-bold">
                      ${item?.product?.price * item.quantity}.00
                    </span>
                  )}
                </p>
              </div>

              <div className="w-36 h-40 min-w-[144px] object-cover flex justify-center items-center bg-slate-200 rounded  ">
                <img
                  src={item?.product?.product_image[0]}
                  alt=""
                  className="w-24 h-24 object-contain mix-blend-multiply hover:scale-110 transition-all ease-in-out duration-500 animate-pulse "
                />
              </div>

              <div className="grid gap-1">
                <h2 className="text-lg  font-semibold text-ellipsis line-clamp-1">
                  {item?.product?.name}
                </h2>
                <p className="text-gray-600 capitalize ">
                  {item?.product?.category}
                </p>
                {item?.product?.discount > 0 ? (
                  <div className="flex flex-row gap-3 items-center">
                    <span className="text-[#6fdedc] text-xl font-bold ">
                      ${item?.product?.discount}
                    </span>
                  </div>
                ) : (
                  <span className="text-[#6fdedc] text-xl font-bold">
                    ${item?.product?.price}
                  </span>
                )}

                <div className="flex justify-between items-center w-[100px] text-center max-w-[100px] mt-2">
                  <button
                    disabled={item?.quantity === 1 || clicked}
                    onClick={(event) => {
                      event.stopPropagation(); // Prevent redirect
                      event.preventDefault();
                      updateQuantity(item?._id, item.quantity - 1);
                    }}
                    className={`flex text-[#6fdedc] hover:bg-[#6fdedc] border border-[#6fdedc] hover:text-white px-2 py-1 w-8 max-w-8 rounded-md text-xl transition-all ${
                      item?.quantity === 1
                        ? "cursor-not-allowed hover:bg-red-600 hover:border-red-600"
                        : ""
                    }`}
                  >
                    <HiMiniMinusSmall />
                  </button>
                  <span className="text-[#000] text-lg font-semibold">
                    {" "}
                    {item?.quantity}{" "}
                  </span>
                  <button
                    disabled={
                      item?.quantity === item?.product?.quantity || clicked
                    }
                    onClick={(event) => {
                      event.stopPropagation(); // Prevent redirect
                      event.preventDefault();
                      updateQuantity(item?._id, item.quantity + 1);
                    }}
                    className={`flex text-[#6fdedc] hover:bg-[#6fdedc] border border-[#6fdedc] hover:text-white px-2 py-1 w-8 max-w-8 rounded-md text-lg transition-all ${
                      item?.quantity === item?.product?.quantity
                        ? "cursor-not-allowed hover:bg-red-600"
                        : ""
                    }`}
                  >
                    <HiPlusSmall />
                  </button>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* summary section  md:fixed md:top-50 md:right-24 */} 
        {data.length > 0 && !loading && (
          <div className="w-full md:w-[35%] md:max-w-[28%] bg-white rounded p-5 ">
            <h2
              style={{ fontFamily: "serif" }}
              className="text-2xl font-bold mb-4 "
            >
              Order Summary
            </h2>
            <hr className="hidden md:flex w-[57%] bg-[#6fdedc] h-[2px] mb-4" />
            <hr className="flex md:hidden w-[54%]  bg-[#6fdedc] h-[1px] mb-4" />
            <div className="flex justify-between mb-4 text-lg">
              <h3 className="text-gray-500">total Quantity</h3>
              <p className="font-bold">{calculateTotalQuantity()}</p>
            </div>

            <div className="flex justify-between mb-4 text-lg">
              <h3 className="text-gray-500">Shipping Charge</h3>
              <p className="font-bold">egp 100</p>
            </div>

            <div className="flex justify-between mb-4 text-lg">
              <h3 className="text-gray-500">Sub total</h3>
              <p className="font-bold">egp {calculateTotal().toFixed(2)}</p>
            </div>

            <div className="flex justify-center items-center mb-0 pt-3 text-lg  min-w-full">
              <button
                onClick={handlePayment}
                style={{ border: "2px solid #fff" }}
                className="w-full flex items-center gap-2 rounded-ee-3xl  justify-center text-white bg-main-background font-bold px-4 py-2 transition-all duration-300 ease-in-out  rounded-md  hover:bg-red-600"
              >
                Payment
                <span className="text-white font-bold">
                  {" "}
                  <MdOutlinePayments />{" "}
                </span>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Cart;
